import React, { Fragment, PureComponent } from 'react';
import b from 'b_';

import './researchers-home-block.css';

import ContentBlock from '@components/content-block';
import EntitiesCarousel from '@components/entities-carousel';
import Button from '@components/button';
import ResearcherBlock from '@components/researcher';
import { Researcher } from '@interfaces/researchers-page';
import { SizesProps } from '@interfaces/sizes-props';
import { isServer } from 'client/store';

interface ComponentProps {
    entities: Researcher[];
    description: string;
    className?: string;
}

type Props = ComponentProps & SizesProps;

export const MOBILE_SWITCH_POINT = 700;
const class_ = b.with('researchers-home-block');
const linkToAllResearchers = { text: 'All people', url: '/people' };
const carouselSettings = {
    slidesToScroll: 1,
    slidesToShow: 3,
    rows: 2,
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                rows: 2
            }
        },
        {
            breakpoint: MOBILE_SWITCH_POINT,
            settings: {
                slidesToShow: 1,
                rows: 1
            }
        }
    ]
};

export default class ResearchersHomeBlock extends PureComponent<Props> {
    public renderLinkButton() {
        const { url, text } = linkToAllResearchers;

        return (
            <Button
                theme="action"
                size="l"
                cls={class_('link-to-all')}
                to={url}
            >
                {text}
            </Button>
        );
    }

    public renderContent() {
        const { entities, isDesktop } = this.props;
        const researchers = entities.map(this.renderResearcher);

        if (isServer) {
            return null;
        }

        return (
            <div className={class_('content')}>
                {isDesktop
                    ? (
                        <div
                            key="flat-researchers"
                            className={`${class_('researchers')} researchers`}
                        >
                            {researchers}
                        </div>
                    )
                    : (
                        <EntitiesCarousel
                            key="researchers-in-carousel"
                            settings={carouselSettings}
                        >
                            {researchers}
                        </EntitiesCarousel>
                    )
                }
            </div>
        );
    }

    public renderDescription() {
        const { description } = this.props;

        return (
            <Fragment>
                {description}
                {this.renderLinkButton()}
            </Fragment>
        );
    }

    public renderResearcher = (researcher: Researcher) => (
        <ResearcherBlock
            key={researcher.id}
            entity={researcher}
        />
    );

    public render() {
        const { className = '' } = this.props;

        return (
            <ContentBlock
                className={`${class_()} ${className}`}
                title="People"
                description={this.renderDescription()}
                content={this.renderContent()}
            />
        );
    }
}
